<template>
  <div v-if="!statusChartData" class="p-2 bg-gray-200 rounted-lg text-[20px] text-gray-400 text-center">
    {{$t('noDataMsg')}}
  </div>
  <canvas id="myChart" width="525" height="262"></canvas>
</template>
<script setup>
import Chart from 'chart.js/auto'
import { onMounted, ref } from 'vue'
import apiHelperService from '@/services'
const myChart = ref()
const labels = ref()
const statusChartData = ref()
const isRefundedFlag = [
  { id: 0, text: 'Total available amount' },
  { id: 1, text: 'Total refunded amount' }
]

const findText = (val) => {
  return isRefundedFlag.find((item) => item.id === val)?.text
}

const getData = async () => {
  const res = await apiHelperService.get('/api/refundRequest/getRefundStatistics')
  if (!res) {
    return
  }

  const [firstItem, secondItem] = res
  const labelPrefix = findText(firstItem.isRefundedFlag)
  const labelSecond = findText(secondItem.isRefundedFlag)
  labels.value = [
    `${labelPrefix} ${firstItem.amount} AED`,
    `${labelSecond} ${secondItem.amount} AED`
  ]
  statusChartData.value = [firstItem.amount, secondItem.amount]
  renderPie()
}

const renderPie = () => {
  const ctx = document.getElementById('myChart')
  const data = {
    labels: labels.value,
    datasets: [
      {
        label: '',
        data: statusChartData.value,
        backgroundColor: ['#c8974c', '#749ab1', '#93bbae', '#da3550'],
        hoverOffset: 4
      }
    ]
  }
  const config = {
    type: 'pie',
    data: data,
    options: {
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true
            }
          }
        ]
      }
    }
  }
  myChart.value = new Chart(ctx, config)
}
onMounted(async () => {
  await getData()
 
})
</script>
